import { WebAnalyticsEvent } from 'hydra-data-types';
import React, { ReactElement, useEffect } from 'react';
import { LayoutScreenConfig, ScreenType } from '../../config/FlowTypes';
import { Analytics } from '../../util/Analytics';
import { ScreenWrapper } from '../styles/Containers';
import { NavigationProps } from './FlowNavigation';
import { PresentationLayout, PresentationLayoutConfig } from './layouts/PresentationLayout';

export type PresentationScreenConfig<ScreenNames extends string> = LayoutScreenConfig<
  ScreenType.Presentation,
  PresentationLayoutConfig,
  ScreenNames
> & {
  secondaryScreen?: ScreenNames;
  /** Analytics event fired once when the screen is shown (e.g. a coverage-outcome result). */
  viewEvent?: WebAnalyticsEvent;
};

type Props<ScreenNames extends string> = NavigationProps<
  PresentationScreenConfig<ScreenNames>,
  ScreenNames
>;

export const PresentationScreen = <ScreenNames extends string>(
  props: Props<ScreenNames>
): ReactElement => {
  useEffect(function fireViewEvent() {
    if (props.viewEvent !== undefined) {
      Analytics.track(props.viewEvent);
    }
  }, []);

  function handlePrimaryButtonPress() {
    props.navigation.next(props);
  }

  // A screen with no nextScreen ends the flow, so there is no next button to render.
  const isFinalScreen = props.nextScreen === undefined;

  return (
    <ScreenWrapper>
      <PresentationLayout
        onPressPrimaryButton={isFinalScreen ? undefined : handlePrimaryButtonPress}
        onPressSecondaryButton={
          props.secondaryScreen === undefined
            ? undefined
            : () => props.navigation.goTo(props.secondaryScreen)
        }
        {...props.layout}
      />
    </ScreenWrapper>
  );
};
